module.exports = "/images/not-plan.svg?e97a44c316c99ddb2a19124e22554aea";